/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateNoteDataSchema = z.object({
	id: z.string(),
	candidateId: z.string(),
	userId: z.string().nullable(),
	userName: z.string().nullable(),
	userEmail: z.string().nullable(),
	content: z.string(),
	editedAt: z.iso.datetime().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	deletedAt: z.iso.datetime().nullable(),
})

export type CandidateNoteDataSchema = z.infer<typeof candidateNoteDataSchema>
